import React from 'react';
import { components } from 'react-select';
import { ReactComponent as ArrowSvg } from 'assets/arrow.svg';

export const DropdownIndicator: typeof components['DropdownIndicator'] = ({
  selectProps,
  ...props
}) => (
  <components.DropdownIndicator selectProps={selectProps} {...props}>
    <ArrowSvg
      style={{
        transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform .1s',
        transformOrigin: 'center',
      }}
    />
  </components.DropdownIndicator>
);
